import { render, staticRenderFns } from "./SearchResultPage.vue?vue&type=template&id=478078cc&scoped=true&"
import script from "./SearchResultPage.vue?vue&type=script&lang=ts&"
export * from "./SearchResultPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478078cc",
  null
  
)

export default component.exports